import { Component, OnInit, Inject } from '@angular/core';
import { PreinvoiceModel } from "../../invoice/preinvoice/preinvoice.model";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvoiceService } from "../../invoice/invoice/invoice.service";
import * as FileSaver from 'file-saver';
import { InvoiceModel } from "../../invoice/invoice/invoice.model";
import { ContactService } from './contact.service';
import { ContactTProviderConst, ContactTClientConst } from '../const';
import { consts } from '../../../consts';
import { ActualSelected, Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-contactInvoices',
    templateUrl: './contact-invoices.component.html',
    styleUrls: ['./contact.component.css'],
    standalone: false
})
export class ContactInvoicesComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private invoiceService: InvoiceService,
        private contactService: ContactService
    ) { }

    dataSource: PreinvoiceModel[] = [];
    uid: string = this.data.uid;
    clientUid: string = this.data.clientUid;
    activity: string = this.data.activity;
    fiscalYear: number = this.data.fiscalYear;
    isClient: boolean = this.data.isClient;
    isProvider: boolean = this.data.isProvider;
    invoice: InvoiceModel;
    ready: boolean = false;
    headerTableP: any[] = ContactTProviderConst.headerTable;
    headerTableC: any[] = ContactTClientConst.headerTable;

    printExcel() {
        this.ready = false;
        if (this.clientUid == null) {
            this.clientUid = consts.EMPTY_GUID;
        }

        this.contactService.excelClient(this.dataSource, this.clientUid).then(response => {
            FileSaver.saveAs(response, Utils.GetExcelName("Contacto_Mayor"));
            this.ready = true;
        })
    }

    printPDF() {
        this.ready = false;
        if (this.clientUid == null) {
            this.clientUid = consts.EMPTY_GUID;
        }

        this.contactService.pdfClient(this.dataSource, this.clientUid).then(response => {
            FileSaver.saveAs(response, Utils.GetPdfName("Contacto_Mayor"));
            this.ready = true;
        })
    }

    ngOnInit() {
        this.ready = false;

        if (this.clientUid == null) {
            this.clientUid = consts.EMPTY_GUID;
        } else {
            this.fiscalYear = ActualSelected.clientYearSelected;
            this.activity = ActualSelected.clientActivitySelected;
        }

        if (this.isClient) {
            this.contactService.loadDataClient(this.uid, this.clientUid).then(response => {
                this.dataSource = response;
                this.ready = true;
            });
        }

        if (this.isProvider) {
            this.contactService.loadDataProvider(this.uid, this.clientUid, this.fiscalYear, this.activity).then(response => {
                this.dataSource = response;
                this.ready = true;
            })
        }


    }

}